import { createDraftJobPost } from './CreateDraftJobPost';
import { createOnsiteInterviews } from './CreateOnsiteInterview';
import { createShortlistCandidate } from './CreateShortlistCandidate';
import { deleteShortlistCandidate } from './DeleteShortlistCandidate';
import { getCandidateList } from './GetCandidateList';
import { getJobPostDetail } from './GetJobPostDetail';
import { getJobPostings } from './GetJobPostings';
import { getOnsiteInterviewList } from './GetOnsiteInterviewList';
import { getOnsiteInterviewStatusCount } from './GetOnsiteInterviewStatusCount';
import { publishDraftJobPost } from './PublishDraftJobPost';
import { saveJobPostDetail } from './SaveJobPostDetail';
import { updateCandidateStatus } from './UpdateCandidateStatus';

export const PermanentJobsApi = {
  createDraftJobPost,
  createOnsiteInterviews,
  createShortlistCandidate,
  deleteShortlistCandidate,
  getCandidateList,
  getJobPostDetail,
  getJobPostings,
  getOnsiteInterviewList,
  getOnsiteInterviewStatusCount,
  publishDraftJobPost,
  saveJobPostDetail,
  updateCandidateStatus,
};
